import BaseValidator from 'services/validations/base-validator';

export default class KeyStatementObjectIsChosenValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {ruleItem, ruleName} = this.dependencies;

        if (ruleItem.isStatementTypePlayer() && !ruleItem.getKeyPlayer()) {
            this.addError(`Key player has to be chosen in ${ruleName}.`);
        } else if (ruleItem.isStatementTypePosition() && !ruleItem.getKeyPosition()) {
            this.addError(`Key position has to be chosen in ${ruleName}.`);
        }
    }
}
